import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const deleteFileStore = (query) => {
    return httpClient.delete(server.UPLOAD_FILE + "/upload-delete", query);
};
